import { render, staticRenderFns } from "./modal-production-write-premium.vue?vue&type=template&id=deb05202&scoped=true&"
import script from "./modal-production-write-premium.vue?vue&type=script&lang=js&"
export * from "./modal-production-write-premium.vue?vue&type=script&lang=js&"
import style0 from "./modal-production-write-premium.vue?vue&type=style&index=0&id=deb05202&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb05202",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('deb05202')) {
      api.createRecord('deb05202', component.options)
    } else {
      api.reload('deb05202', component.options)
    }
    module.hot.accept("./modal-production-write-premium.vue?vue&type=template&id=deb05202&scoped=true&", function () {
      api.rerender('deb05202', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/calculations/create/additions/modal-production-write-premium.vue"
export default component.exports